<script>
    import "./projectPreview.css";
    import {ethers} from "ethers";
    import {getProjectMetaService, salesQuery} from "../../../services/api";
    import {getProjectDetailService} from "../../../services/projectDetailService";
    import {
        isLoaderActive,
        isTransactionConfirmed,
        projectDetail,
        projectSaleDetails,
        tokenPurchased
    } from "../../store";
    import SaleArtifact from "../../abi/Sale.json";
    import {signer, signerAddress} from 'svelte-ethers-store'
    import {
        formatNumber,
        getAfterTimestampDate,
        getAfterTimeStampStrapi,
        getERC20,
        getTime,
        getTokenPrice,
        getWalletCap,
        sliceOffDecimalNumbers
    } from "../../utils";
    import ProjectCardPreview from "./project-card-preview/ProjectCardPreview.svelte"
    import ProjectPreviewTab from "./project-preview-tab/ProjectPreviewTab.svelte";
    import ProjectDetailPreview from "./project-preview-tab/project-detail-preview/ProjectDetailPreview.svelte";
    import {formatUnits} from "ethers/lib/utils";
    import ProjectTokenDetail from "./project-preview-tab/project-token-detail/ProjectTokenDetail.svelte";
    import ProjectTransactionTab from "./project-preview-tab/project-transaction-tab/ProjectTransactionTab.svelte";
    import {getSaleTransactionMetaService} from "../../../services/saleTransactionApi";
    import {ABSOLUTE_ZERO_REGEX, PARTIAL_TIME_FORMAT, transactionType} from "../../constants/constants";

    export let params = {};
    let currentStep = 1

    const PriceConfirmed = {
        PENDING: 'pending',
        CONFIRMED: 'confirmed',
    }

    let tokenValues, reserveValues, saleContract, saleData, projectTierData;

    let fee, priceConfirmed = PriceConfirmed.PENDING ,projectMeta

    $: saleCardDetails = {
        saleAddress: $projectDetail.sale_address,
        raiseTarget: $projectDetail.project_raise_target,
        totalSupply: $projectDetail.total_available_token,
        startTime: getAfterTimeStampStrapi($projectDetail.project_start_time, PARTIAL_TIME_FORMAT),
        endTime: getAfterTimeStampStrapi($projectDetail.project_end_time, PARTIAL_TIME_FORMAT),
        walletCap: $projectDetail.individual_purchase_limit ,
        totalRaised: "",
        price: $projectDetail.project_token_price,
        percentRaised: "",
        tokenName: $projectDetail.token_name,
        tokenSymbol: $projectDetail.token_symbol
    }
    $: if(projectMeta) {
        $projectDetail.sale_address && setInterval(() => {
            const {timeRemaining} = getTime(projectMeta);
            saleCardDetails.endTime = timeRemaining
        }, 1000);
    }

    const setTokenPrice = async () => {
        if(params.address){
            const {sale, reserve, token} = await initSaleContract($signer, params.address);
            saleContract = sale;
            reserveValues = reserve;
            tokenValues = token;
        }
    }

    $: if($signerAddress) {
        setTokenPrice();
    }

    const setCurrentStep = (newStep) => {
        currentStep = newStep
    }

    const setProjectDetail = async () => {
        const projectDetailResp = await getProjectDetailService(params.projectId);
        projectTierData = projectDetailResp && projectDetailResp.wallet_tier;
        projectDetail.set(projectDetailResp);
    }

    signerAddress.subscribe(async () => await getSalesTransactions())

    function sumOfToken (token) {
        tokenPurchased.set($tokenPurchased+token)
    }

    async function getSalesTransactions () {
        tokenPurchased.set(0)
        if($signerAddress && params.address){
            const transactions = await getSaleTransactionMetaService(params.address, $signerAddress)
            transactions.data.saleTransactions.forEach((transaction) => {
                sumOfToken(transaction.__typename === transactionType.Buy ? formatNumber(transaction.receipt.units, transaction.saleContract.token.decimals) : -(formatNumber(transaction.receipt.units, transaction.saleContract.token.decimals)))
            })
        }
    }

    const setProjectData = async () => {
        if(params.address) {
            const { data } = await getProjectMetaService(params.address);
            projectMeta = data.sales[0]
            saleData = await salesQuery(params.address);
            setSaleData(data.sales[0]);
            await getSalesTransactions()
        }
    }

    const setSaleData = (sale) => {
        projectSaleDetails.set(sale)
        saleCardDetails = {
            project_address: projectSaleDetails.sale_address,
            raiseTarget: (Number(formatUnits(sale.minimumRaise, sale.reserve.decimals))),
            totalSupply: Number(+formatUnits(sale.token.totalSupply, sale.token.decimals)),
            startTime: getAfterTimestampDate(sale.canStartStateConfig).toLocaleString(),
            walletCap: getWalletCap(sale),
            totalRaised: Number((+formatUnits(sale.totalRaised, sale.reserve.decimals))),
            price: getTokenPrice(sale),
            tokenName: sale.token.name,
            tokenSymbol: sale.token.symbol,
            percentRaised: sale.percentRaised
        }
    }

    export const initSaleContract = async (signer, address) => {
        isLoaderActive.set(true)
        const sale = new ethers.Contract(address, SaleArtifact.abi, signer);
        const reserve = await getERC20(await sale.reserve(), signer);
        const token = await getERC20(await sale.token(), signer);
        isLoaderActive.set(false)
        return {sale, reserve, token};
    };
    setProjectData();
    setProjectDetail();

    $: if($isTransactionConfirmed) {
        setProjectData();
        setProjectDetail();
        (async () => await getSalesTransactions())()
        isTransactionConfirmed.set(false);
    }
</script>
<div class="project-preview-setup">
    <div class="container">
        <ProjectCardPreview {projectTierData} {saleCardDetails} {saleData} sale={saleContract} reserve={reserveValues} token={tokenValues}/>
    </div>
    <ProjectPreviewTab {setCurrentStep} {currentStep} {saleContract}/>
    <div class="tabs-section">
        <div class="container">
            {#if currentStep === 1 }
                <ProjectDetailPreview />
            {/if}
            {#if currentStep === 2 }
                <ProjectTokenDetail />
            {/if}
            {#if currentStep === 3 }
                <ProjectTransactionTab endTime={saleCardDetails.endTime} saleContract={saleContract} bind:currentStep={currentStep}/>
            {/if}
        </div>
    </div>
</div>
